import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { PackageManagementComponent } from './package-management/package-management.component';
import { PackagesManagementComponent } from './packages-management/packages-management.component';
import { ExportedFoldersComponent } from './exported-folders/exported-folders.component';
import { ActionHistoryComponent } from './action-history/action-history.component';
import { HistoryModule } from '../history/history.module';
import { WorkshopsComponent } from './workshops/workshops.component';
import { PackagingKpiComponent } from './packaging-kpi/packaging-kpi.component';
import { PackageListsService } from '../../services/packageLists/package-lists.service';
import { ExportedFoldersService } from '../../services/exported-folders/exported-folders.service';
import { ActionHistoryService } from '../../services/actionHistory/action-history.service';
import { WorkshopsService } from '../../services/workshops/workshops.service';
import { SparePartsService } from '../../services/spareParts/spare-parts.service';
import { OrdersService } from '../../services/orders/orders.service';
import { PendingPackagesService } from '../../services/pending-packages/pending-packages.service';
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { KpiAccessGuard } from '../../guards/kpi-access.guard';

@NgModule({
  declarations: [
    AdminDashboardComponent,
    PackageManagementComponent,
    PackagesManagementComponent,
    ExportedFoldersComponent,
    ActionHistoryComponent,
    WorkshopsComponent,
    PackagingKpiComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HistoryModule,
    RouterModule.forChild([
      { path: '', component: AdminDashboardComponent },
      { path: 'package-management', component: PackageManagementComponent },
      { path: 'packages-management', component: PackagesManagementComponent },
      { path: 'exported-folders', component: ExportedFoldersComponent },
      { path: 'action-history', component: ActionHistoryComponent },
      { path: 'workshops', component: WorkshopsComponent },
      { path: 'packaging-kpi', component: PackagingKpiComponent, canActivate: [KpiAccessGuard] }
    ])
  ],
  providers: [
    PackageListsService,
    ExportedFoldersService,
    ActionHistoryService,
    WorkshopsService,
    SparePartsService,
    OrdersService,
    PendingPackagesService,
    ConfigurationService
  ]
})
export class AdminModule { } 